__turbopack_context__.v({
  "card-edit-input-container": "UrlEditPopover-module-scss-module__6mTRMG__card-edit-input-container",
  "card-edit-select": "UrlEditPopover-module-scss-module__6mTRMG__card-edit-select",
  "card-edit-select-container": "UrlEditPopover-module-scss-module__6mTRMG__card-edit-select-container",
  "phone-number-input": "UrlEditPopover-module-scss-module__6mTRMG__phone-number-input",
  "suggestions-section-container": "UrlEditPopover-module-scss-module__6mTRMG__suggestions-section-container",
  "type-label": "UrlEditPopover-module-scss-module__6mTRMG__type-label",
  "url-preview": "UrlEditPopover-module-scss-module__6mTRMG__url-preview",
  "url-preview-content-container": "UrlEditPopover-module-scss-module__6mTRMG__url-preview-content-container",
  "url-preview-icon": "UrlEditPopover-module-scss-module__6mTRMG__url-preview-icon",
  "value-input-container": "UrlEditPopover-module-scss-module__6mTRMG__value-input-container",
});
